import { Controller } from "@hotwired/stimulus"

/**
 * Moves focus to this element as soon as it appears, and scrolls it into view.
 *
 * For whatever a turbo response wants read next. A failed submit re-renders the form,
 * and the browser restores neither scroll position nor focus - you are left looking at
 * the submit button with no sign that anything happened, which reads as "the save was
 * lost" rather than "the save was refused". Focusing the summary answers both: the
 * viewport follows focus, and a screen reader announces the alert it has just landed in.
 *
 * The same holds for a successful save that re-renders a long list: the row that was
 * just saved is the one thing worth landing on.
 *
 * The element needs tabindex="-1" to be focusable without joining the tab order.
 *
 * preventScroll then scrollIntoView rather than letting focus() scroll: focus() jumps
 * the element to the very top edge, hiding it under the sticky header on this layout.
 *
 * Expected markup:
 *   <div role="alert" tabindex="-1" data-controller="focus-on-load">…</div>
 */
export default class extends Controller {
  connect() {
    // A frame swap can connect this before layout has settled, and scrolling to an
    // element that has not been placed yet lands in the wrong spot.
    requestAnimationFrame(() => {
      this.element.focus({ preventScroll: true })
      this.element.scrollIntoView({ behavior: "smooth", block: "center" })
    })
  }
}
